module.exports = __webpack_public_path__ + "img/csa_button_legends.60d0f757.png";